export default function extractStyleParams(element) {
  let style = {};
  let length = element.attributes.length;

  for (var i = 0; i < length; i++) {
    let item = element.attributes.item(i);
    if (item.name.match(/data-dubbletrack-style/)) {
      let name = item.name.replace('data-dubbletrack-style-', '');

      let parts = name.split('-');
      let lastSegment = parts.pop();
      if (lastSegment == 'color') {
        parts.unshift(lastSegment);
      } else {
        parts.push(lastSegment);
      }

      let key = parts.join('-');
      let isColor = key.includes('color');
      if (isColor && item.value.match(/^[0-9a-fA-F]+$/)) {
        style[key] = `#${item.value}`;
      } else {
        style[key] = item.value;
      }
    }
  }

  return style;
}
